const styles = {

  signin: {
    background: '#EFF3F6',
    flex: 1,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },

  logoSignin: {
    paddingTop: 10
  },

  siginForm: {
    width: 450,
    border: "1px solid #ddd",
    padding: 15,
    borderRadius: '0 0 5px 5px',
    background: 'white',
  },

  title: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: 5,
    marginBottom: 5
  },

  subTitle: {
    fontSize: 12
  },

  input: {
    width: 237,
    height: 32,
    borderRadius: 3,
    color: 'black',
  },

  btnSignin: {
    width: 236,
    height: 32,
    fontSize: 14,
    fontWeight: 400,
    borderRadius: 50,
  },

  fotterSignin: {
    textAlign: 'center',
    fontSize: 14,
    color: '#B5B2B2',
    padding: '30px 0',
  }

  
}

export default styles;